import React from 'react';
import { useWebMCP } from 'usewebmcp';
import { executeGenerateColorScale } from './executors/generateColorScale';
import { BASE_COLOR_INPUT_SCHEMA } from './schemas/inputSchemas';

export const GenerateScaleTool: React.FC = () => {
  useWebMCP({
    name: 'generate_color_scale',
    description:
      'Generate an accessible contrast-first color scale from a base color. Returns hex swatches with contrast ratios at each step. Use when someone wants an accessible palette or color ramp starting from a specific color.',
    inputSchema: BASE_COLOR_INPUT_SCHEMA,
    annotations: { readOnlyHint: true },
    execute: executeGenerateColorScale,
  });

  return null;
};
